var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", [
    _c(
      "div",
      { staticStyle: { "overflow-y": "auto", height: "400px" } },
      [
        _c("subtitle-totals", {
          staticClass: "title is-6",
          attrs: {
            labels: ["Return Total", "GST"],
            totals: [_vm.returnTotalWithOtherFee, _vm.returnTotalGst],
            shows: [true, true],
          },
        }),
        _c(
          "bulma-table",
          {
            staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.columns,
              "total-rows": !_vm.value ? 0 : _vm.value.length,
              "show-pagination": false,
            },
          },
          [
            _vm._l(_vm.value, function (item, index) {
              return _c(
                "tr",
                {
                  key: item.dealerCreditID,
                  class: { "is-selected": _vm.selectedRow === index },
                },
                [
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.poNumber)),
                    ]),
                  ]),
                  _c("td", [
                    _c(
                      "div",
                      { staticClass: "has-vertical-middle quote-col" },
                      [
                        item.quoteDeleted
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "icon has-text-danger tooltip is-tooltip-danger",
                                staticStyle: { "padding-right": "3px" },
                                attrs: {
                                  "data-tooltip": "Quote has been deleted.",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-alert mdi-18px",
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" " + _vm._s(item.quoteNo) + " "),
                      ]
                    ),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-text-right" }, [
                      _vm._v(_vm._s(item.invNo)),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatDateTimezone(
                            item.invDate,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.recd)),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.returnNo)),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatDateTimezone(
                            item.returnDate,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.retd)),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.cred)),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.qtyLeft)),
                    ]),
                  ]),
                  _c(
                    "td",
                    { attrs: { width: "5%" } },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          minus: false,
                          placeholder: "Qty",
                          min: 0,
                          disabled:
                            _vm.isReadOnly ||
                            _vm.value[index].creditReturnID === _vm.emptyGuid ||
                            (_vm.selectedPO != item.purchaseOrderID &&
                              _vm.selectedPO != null),
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.calculateTotal("qty")
                          },
                          input: function ($event) {
                            return _vm.checkIsSamePO(
                              item.purchaseOrderID,
                              item.credQty
                            )
                          },
                        },
                        model: {
                          value: item.credQty,
                          callback: function ($$v) {
                            _vm.$set(item, "credQty", _vm._n($$v))
                          },
                          expression: "item.credQty",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { attrs: { width: "12%" } },
                    [
                      !_vm.isReadOnly
                        ? _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              minus: false,
                              placeholder: "Amount Required",
                              min: 0.0,
                              disabled:
                                _vm.isReadOnly ||
                                _vm.value[index].creditReturnID ===
                                  _vm.emptyGuid ||
                                (_vm.selectedPO != item.purchaseOrderID &&
                                  _vm.selectedPO != null),
                              precision: 2,
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.calculateTotal()
                              },
                              input: function ($event) {
                                return _vm.checkIsSamePO(
                                  item.purchaseOrderID,
                                  item.credQty
                                )
                              },
                            },
                            model: {
                              value: item.excGST,
                              callback: function ($$v) {
                                _vm.$set(item, "excGST", _vm._n($$v))
                              },
                              expression: "item.excGST",
                            },
                          })
                        : _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              minus: false,
                              placeholder: "Amount Required",
                              min: 0.0,
                              disabled:
                                _vm.isReadOnly ||
                                _vm.value[index].creditReturnID ===
                                  _vm.emptyGuid ||
                                (_vm.selectedPO != item.purchaseOrderID &&
                                  _vm.selectedPO != null),
                              precision: 2,
                            },
                            model: {
                              value: item.amtExcGST,
                              callback: function ($$v) {
                                _vm.$set(item, "amtExcGST", _vm._n($$v))
                              },
                              expression: "item.amtExcGST",
                            },
                          }),
                    ],
                    1
                  ),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.partNo)),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.script)),
                    ]),
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.reason)),
                    ]),
                  ]),
                  _c(
                    "td",
                    { attrs: { width: "10%" } },
                    [
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          minus: false,
                          placeholder: "Fee Required",
                          min: 0.0,
                          disabled:
                            _vm.isReadOnly ||
                            _vm.value[index].creditReturnID === _vm.emptyGuid ||
                            (_vm.selectedPO != item.purchaseOrderID &&
                              _vm.selectedPO != null),
                          precision: 2,
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.calculateTotal()
                          },
                          input: function ($event) {
                            return _vm.checkIsSamePO(
                              item.purchaseOrderID,
                              item.credQty
                            )
                          },
                        },
                        model: {
                          value: item.otherFee,
                          callback: function ($$v) {
                            _vm.$set(item, "otherFee", _vm._n($$v))
                          },
                          expression: "item.otherFee",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("td", { staticClass: "has-text-centered" }, [
                    !item.otherReason
                      ? _c("a", { staticClass: "tag is-primary" }, [
                          _c("span", [
                            _c("i", {
                              staticClass: "mdi mdi-file-document",
                              on: {
                                click: function ($event) {
                                  return _vm.addOtherReason(index)
                                },
                              },
                            }),
                          ]),
                        ])
                      : _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: { enabled: true },
                                expression: "{ enabled: true }",
                              },
                            ],
                            staticClass: "tag is-success",
                            attrs: { content: item.otherReason },
                          },
                          [
                            _c("span", [
                              _c("i", {
                                staticClass: "mdi mdi-file-document",
                                on: {
                                  click: function ($event) {
                                    return _vm.addOtherReason(index)
                                  },
                                },
                              }),
                            ]),
                          ]
                        ),
                  ]),
                ]
              )
            }),
            _c("template", { slot: "empty" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c("span", { attrs: { icon: "icon is-large" } }, [
                    _c("i", { staticClass: "mdi mdi-36px mdi-emoticon-sad" }),
                  ]),
                  _c("p", [_vm._v("Nothing")]),
                ]
              ),
            ]),
          ],
          2
        ),
        _vm.isOtherReasonModelActive
          ? _c(
              "delaer-credit-entry-other-reason-modal",
              {
                attrs: {
                  "selected-item": _vm.selectedReason,
                  active: _vm.isOtherReasonModelActive,
                  value: _vm.value,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.isOtherReasonModelActive = $event
                  },
                  cancel: function ($event) {
                    return _vm.closeOtherModal($event)
                  },
                },
              },
              [
                _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                  _vm._v("Add Notes"),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }